import { React } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, Autocomplete, Box } from '@mui/material';
import axios from 'axios';
import { environment } from '../../environments/environment';
import { checkIfServerError } from '../../actions/AuthActionsAPI';
import { useState } from 'react';
import { useEffect } from 'react';
import { toaster } from '../../components/common/Toaster';
import { countryDetails } from '../../constants/listOfCountriesAndStates';
import { debounce } from 'lodash';
import { PortalClientStorage } from '../../services/client-storage/storage';
import { useTranslation } from 'react-i18next';
export const _handleCountryChange = (event, setSelectedCountry, setSelectedState, setFormData, formData) => {
    setSelectedCountry(event.target.innerHTML);
    setSelectedState('');
    setFormData({ ...formData, country: event.target.innerHTML });
};

export const _handleStateChange = (event, setSelectedState, setFormData, formData) => {
    setSelectedState(event.target.innerHTML);
    setFormData({ ...formData, region_states: event.target.innerHTML });
};

export function EditProfile(props) {
    const { formProps, setAvatarText,setName } = props;
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        organization: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        electricUtility: '',
        title: '',
        country: '',
        region: '',
        email: '',
        region_states: '',
    });

    const [requiredFirstName, setRequiredFirstName] = useState(false);
    const [requiredLastName, setRequiredLastName] = useState(false);
    const [requiredCountry, setRequiredCountry] = useState(false);
    const [requiredOrganization, setRequiredOrganization] = useState(false);
    const [requiredTitle, setRequiredTitle] = useState(false);

    const [disabled, setDisabled] = useState(true);
    useEffect(() => {
        fetchUserData();
    }, []);

    useEffect(() => {
        if (requiredFirstName || requiredLastName || requiredCountry || requiredOrganization || requiredTitle) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [requiredFirstName, requiredLastName, requiredCountry, requiredOrganization, requiredTitle]);

    useEffect(() =>{
        const requiredFields = ['firstName', 'lastName', 'title', 'organization', 'country'];
        requiredFields.forEach(el => {
            checkRequired(el);
        });
    }, [formData])

    const handleTextFieldBlur = (event) => {
        checkRequired(event.target.name);
    }

    const checkRequired = (field) => {
        if (field === 'firstName') {
            (formData.firstName && formData.firstName.length > 0) ? setRequiredFirstName(false) : setRequiredFirstName(true);
        }
        if (field === 'lastName') {
            (formData.lastName && formData.lastName.length > 0) ? setRequiredLastName(false) : setRequiredLastName(true);
        }
        if (field === 'organization') {
            (formData.organization && formData.organization.length > 0) ? setRequiredOrganization(false) : setRequiredOrganization(true);
        }
        if (field === 'title') {
            (formData.title && formData.title.length > 0) ? setRequiredTitle(false) : setRequiredTitle(true);
        }
        if (field === 'country') {
            (formData.country?.length > 0) ? setRequiredCountry(false) : setRequiredCountry(true);
        }
    };

    const baseURL = environment.baseURL;

    const countries = countryDetails;

    const handleClose = () => {
        formProps(false);
    };
    const handleUpdate = () => {
        updateUserData();
    };

    const handleChange = (event) => {
        let { name, value } = event.target;
        if(name === 'phoneNumber'){
            value = value.replace(/[^0-9]/g, '')
        }
        //Below logic is to avoid any special characters and numbers in mentioned fields
        // if(name = 'firstName'){
        //     value = value.replace(/[^a-zA-Z]/g, '')
        // }else if(name === 'lastName'){
        //     value = value.replace(/[^a-zA-Z]/g, '')
        // }else if(name === 'title'){
        //     value = value.replace(/[^a-zA-Z]/g, '')
        // }else if(name === 'organization'){
        //     value = value.replace(/[^a-zA-Z]/g, '')
        // }

        checkRequired(name);
        if (value.trim().length === 0) {
            if (name === 'firstName') {
                setRequiredFirstName(true);
            } else if (name == 'lastName') {
                setRequiredLastName(true);
            } else if (name == 'title') {
                setRequiredTitle(true);
            } else if (name == 'organization') {
                setRequiredOrganization(true);
            } else if (name == 'country') {
                setRequiredCountry(true);
            }
        }
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const fetchedEmail = JSON.parse(window.localStorage.getItem('user_data'))['user'];

    let configParamsWithoutAuth = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    };
    const fetchUserData = () => {
        const authorizationToken = 'Bearer ' + window.localStorage.getItem('accessToken');
        configParamsWithoutAuth['headers']['Authorization'] = authorizationToken;
        const fetchData = axios.get(`${baseURL}/security/account/current`, configParamsWithoutAuth);
        fetchData
            ?.then((data) => {
                // React 18+ automatically batches these state updates
                setFormData({
                    organization: data?.data?.data?.company_name,
                    firstName: data?.data?.data?.first_name,
                    lastName: data?.data?.data?.last_name,
                    phoneNumber: data?.data?.data?.phone_number,
                    electricUtility: data?.data?.data?.electric_utility,
                    title: data?.data?.data?.job_title,
                    country: data?.data?.data?.country,
                    region: data?.data?.data?.region_states,
                });
                setSelectedCountry(data?.data?.data?.country);
                const userDetails = {email: fetchedEmail, name: data?.data?.data?.display_name, rememberMe: false};
                PortalClientStorage.setData('userDetails', JSON.stringify(userDetails), true);
                setSelectedState(data?.data?.data?.region_states);
            })
            .catch((err) => {
                if (checkIfServerError()) {
                    toaster(`${err?.message}`);
                }
            });
    };
    const updateUserData = debounce(() => {
        const authorizationToken = 'Bearer ' + window.localStorage.getItem('accessToken');
        configParamsWithoutAuth['headers']['Authorization'] = authorizationToken;
        const updatedData = {
            company_name: formData?.organization,
            country: formData?.country,
            display_name: formData?.firstName + ' ' + formData?.lastName,
            electric_utility: formData?.electricUtility,
            email: fetchedEmail,
            first_name: formData?.firstName,
            job_title: formData?.title,
            last_name: formData?.lastName,
            licenseVersion: '1',
            phone_number: formData?.phoneNumber,
            region_states: formData?.region_states,
            requestedProducts: [],
        };
        formProps(false);
        const updateData = axios.post(`${baseURL}/security/account/update`, updatedData, configParamsWithoutAuth);
        updateData
            ?.then((data) => {
                if (data.data.message == 'Account Updated') {
                    const userDetails = JSON.parse(PortalClientStorage.getData('userDetails', true));
                    const updatedUserDetails = {...userDetails, name: formData?.firstName + ' ' + formData?.lastName};
                    PortalClientStorage.setData('userDetails', JSON.stringify(updatedUserDetails), true);
                    const name = formData?.firstName?.slice('')[0] + '' + formData?.lastName?.slice('')[0];
                    setAvatarText(name);
                    setName(formData.firstName + ' ' + formData.lastName);
                    toaster(data?.data?.message, 'Success');
                    formProps(false);
                }
            })
            .catch((err) => {
                formProps(false);
                if (checkIfServerError()) {
                    toaster(`${err?.message}`);
                }
            });
    }, 1000);

    const [selectedCountry, setSelectedCountry] = useState(formData.country || null);
    const [selectedState, setSelectedState] = useState(formData.region_states || null);

    return (
        <div data-testid="profileComponent" className="profile-component">
            <Dialog open={true} onClose={handleClose} PaperProps={{ style: { width: '100%' } }}>
                <DialogTitle>Edit Profile</DialogTitle>
                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        autoFocus
                        error={requiredFirstName}
                        name="firstName"
                        margin="dense"
                        id="fname"
                        label={t('translation:pages.user_account.edit_profile.firstName')}
                        type="text"
                        fullWidth={true}
                        onBlur={(event) => handleTextFieldBlur(event)}
                        helperText={requiredFirstName && t('translation:validation.editProfile.firstNameRequired')}
                        required={requiredFirstName}
                        variant="standard"
                        value={formData.firstName}
                        InputLabelProps={{
                            shrink: Boolean(formData.firstName),
                        }}
                        inputProps={{
                            maxLength: 34,
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        name="lastName"
                        error={requiredLastName}
                        margin="dense"
                        id="lname"
                        label={t('translation:pages.user_account.edit_profile.lastName')}
                        type="text"
                        fullWidth={true}
                        onBlur={(event) => handleTextFieldBlur(event)}
                        variant="standard"
                        value={formData.lastName}
                        required={requiredLastName}
                        helperText={requiredLastName && t('translation:validation.editProfile.lastNameRequired')}
                        InputLabelProps={{
                            shrink: Boolean(formData.lastName),
                        }}
                        inputProps={{
                            maxLength: 34,
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        margin="dense"
                        id="email"
                        label={t('translation:pages.user_account.edit_profile.email')}
                        type="email"
                        fullWidth={true}
                        variant="standard"
                        value={fetchedEmail}
                        disabled={true}
                        className="editProfile-Textfields"
                    />
                </DialogContent>

                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        name="phoneNumber"
                        margin="dense"
                        id="phoneNumber"
                        label={t('translation:pages.user_account.edit_profile.phoneNumber')}
                        fullWidth={true}
                        variant="standard"
                        value={formData.phoneNumber}
                        InputLabelProps={{
                            shrink: Boolean(formData.phoneNumber),
                        }}
                        inputProps={{
                            maxLength: 16,
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <Box>
                        <Autocomplete
                            data-testid="country-autocomplete"
                            options={countries.map((country) => country.Name)}
                            value={selectedCountry}
                            onChange={(event) => {
                                _handleCountryChange(
                                    event,
                                    setSelectedCountry,
                                    setSelectedState,
                                    setFormData,
                                    formData
                                );
                            }}
                            InputLabelProps={{
                                shrink: Boolean(true),
                            }}
                            InputProps={{
                                style: { padding: '12px 12px', margin: '2px 0' },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('translation:pages.user_account.edit_profile.country')}
                                    name="country"
                                    InputLabelProps={{
                                        style: { marginLeft: '0px', marginTop: selectedCountry ? '8px' : '0px' },
                                        'data-testid': 'country-textfield',
                                    }}
                                    error={requiredCountry}
                                    required={requiredCountry}
                                    helperText={requiredCountry && t('translation:validation.editProfile.countryRequired')}
                                />
                            )}
                        />
                    </Box>
                    <Box sx={{ marginTop: '30px' }}>
                        {selectedCountry && (
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={countries
                                        ?.find((country) => country.Name !== '' && country.Name === selectedCountry)
                                        ?.States?.map((state) => state.Name)}
                                    defaultValue={selectedState}
                                    value={selectedState}
                                    onChange={(event) => {
                                        _handleStateChange(event, setSelectedState, setFormData, formData);
                                    }}
                                    InputLabelProps={{
                                        shrink: Boolean(true),
                                    }}
                                    InputProps={{
                                        style: { padding: '12px 12px', margin: '2px 0' },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('translation:pages.user_account.edit_profile.state')}
                                            InputLabelProps={{
                                                style: { marginLeft: '0px', marginTop: selectedState ? '12px' : '0px' },
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        )}
                    </Box>
                </DialogContent>
                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        margin="dense"
                        error={requiredOrganization}
                        name="organization"
                        id="oraganization"
                        label={t('translation:pages.user_account.edit_profile.org')}
                        type="text"
                        fullWidth={true}
                        onBlur={(event) => handleTextFieldBlur(event)}
                        variant="standard"
                        value={formData.organization}
                        required={requiredOrganization}
                        helperText={requiredOrganization &&  t('translation:pages.user_account.edit_profile.orgIsRequired')}
                        InputLabelProps={{
                            shrink: Boolean(formData.organization),
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        name="electricUtility"
                        margin="dense"
                        id="electricUtility"
                        label={t('translation:pages.user_account.edit_profile.electricUtility')}
                        type="text"
                        fullWidth={true}
                        variant="standard"
                        value={formData.electricUtility}
                        InputLabelProps={{
                            shrink: Boolean(formData.electricUtility),
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogContent sx={{ overflowY: 'visible', margin: '-5px 0' }}>
                    <TextField
                        name="title"
                        margin="dense"
                        error={requiredTitle}
                        id="title"
                        label={t('translation:pages.user_account.edit_profile.title')}
                        type="text"
                        fullWidth={true}
                        onBlur={(event) => handleTextFieldBlur(event)}
                        variant="standard"
                        required={requiredTitle}
                        helperText={requiredTitle && t('translation:pages.user_account.edit_profile.titleIsRequired')}
                        value={formData.title}
                        InputLabelProps={{
                            shrink: Boolean(formData.title),
                        }}
                        className="editProfile-Textfields"
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogActions>
                    <Button id="cancelButton" onClick={handleClose} data-testid="cancel-button">
                        {t('translation:pages.user_account.edit_profile.cancelButton')}
                    </Button>
                    <Button id="submitButton" onClick={handleUpdate} data-testid="submit-button" disabled={disabled}>
                        {t('translation:pages.user_account.edit_profile.updateButton')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}